// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.details_cardWrapper__au3Nl {
  border-bottom: 1px solid var(--mui-palette-grey-400);
  max-height: 270px;
}

.details_titleIcon__rqU6K {
  scale: 0.9;
  padding: 5px;
}

.details_mapWrapper__CfWgh {
  width: 100%;
  height: 350px;
}

.details_mapWrapper__CfWgh .mapboxgl-map {
  border-radius: 6px;
}

.details_actionListWrapper__xxLqv {
  width: 100%;
  padding-top: 12px;
}

.details_iconColor__uVh\\+0 {
  stroke: var(--mui-palette-primary-400);
  stroke-width: 0;
  fill: var(--mui-palette-primary-400);
}

.details_homeColor__jN\\+9i {
  stroke: var(--mui-palette-primary-400) !important;
  stroke-width: 0;
  fill: var(--mui-palette-primary-400) !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/manage-restaurants/details/index.module.css"],"names":[],"mappings":"AAAA;EACE,oDAAoD;EACpD,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,iDAAiD;EACjD,eAAe;EACf,+CAA+C;AACjD","sourcesContent":[".cardWrapper {\n  border-bottom: 1px solid var(--mui-palette-grey-400);\n  max-height: 270px;\n}\n\n.titleIcon {\n  scale: 0.9;\n  padding: 5px;\n}\n\n.mapWrapper {\n  width: 100%;\n  height: 350px;\n}\n\n.mapWrapper :global .mapboxgl-map {\n  border-radius: 6px;\n}\n\n.actionListWrapper {\n  width: 100%;\n  padding-top: 12px;\n}\n\n.iconColor {\n  stroke: var(--mui-palette-primary-400);\n  stroke-width: 0;\n  fill: var(--mui-palette-primary-400);\n}\n\n.homeColor {\n  stroke: var(--mui-palette-primary-400) !important;\n  stroke-width: 0;\n  fill: var(--mui-palette-primary-400) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardWrapper": `details_cardWrapper__au3Nl`,
	"titleIcon": `details_titleIcon__rqU6K`,
	"mapWrapper": `details_mapWrapper__CfWgh`,
	"actionListWrapper": `details_actionListWrapper__xxLqv`,
	"iconColor": `details_iconColor__uVh+0`,
	"homeColor": `details_homeColor__jN+9i`
};
export default ___CSS_LOADER_EXPORT___;
